export class PluginRetrievalUtils {
    getPluginFromDiagram(payload, fabricDiagramCtx) {
        const pluginId = payload.pluginId || payload;
        if (!pluginId) this.pluginNotFound(pluginId);
        const plugin = fabricDiagramCtx.plugins.find(
            plugin => plugin.id === pluginId
        );
        if (!plugin) this.pluginNotFound(pluginId);
        return plugin;
    }

    pluginNotFound(pluginId) {
        console.error(`Plugin '${pluginId}' not found!`);
    }
}
